import { render, staticRenderFns } from "./SpecialClassifications.vue?vue&type=template&id=72e3aa62"
import script from "./SpecialClassifications.vue?vue&type=script&lang=js"
export * from "./SpecialClassifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports